import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import { Button as PrimeButton } from "primereact/button";
import { Dialog } from "primereact/dialog";
import ToolTip from "../../common/ToolTip";
import usePermission from "../../../usePermission"
import { GoogleMaterialIcon } from "../../ui/GoogleMaterialIcon";
import { ICONS } from "../../../constants/icons";
import { useCommonDetailsContext } from "../../../context/Common/common";
import { tokens } from "../../../theme/tokens";

export default function DeferredToolbox(props) {
  const navigate = useNavigate();
  const { publishedBranding, clientScopedBranding, validateParentData } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent ? publishedBranding : (clientScopedBranding || publishedBranding);
  const primaryColor =
    activeBranding?.primaryColor || tokens.colors.connectedPurple;

  const showClientProfileList = () => {
    navigate("/");
  };



  const displayHistory = () => {
    props.displayHistory();
  };
  const addComment = () => {
    props.addComment();
  };
  const displayTracker = () => {
    props.trackerPage();
  }

  return (
    <React.Fragment>
      <Box sx={{ width: "100%", maxWidth: 360, bgcolor: "#fff", borderRadius: "50px !important", padding: "16px 8px" }}>
        <nav aria-label="main mailbox folders">
          <List>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="">
                <ListItemButton disabled={props.isLoading} sx={{ justifyContent: "center" }}>
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.FILTER_LIST} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Client Profile List">
                <ListItemButton
                  onClick={showClientProfileList}
                  disabled={props.isLoading}
                  sx={{ justifyContent: "center" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.HOME} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
          </List>
        </nav>
        <Divider sx={{ width: "80%", margin: "0 auto", backgroundColor: primaryColor }} />
        <nav aria-label="secondary mailbox folders">
          <List>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Client Tracker List">
                <ListItemButton
                  disabled={props.isLoading}
                  onClick={displayTracker}
                  sx={{ justifyContent: "center" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.LIST} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Activity History">
                <ListItemButton
                  onClick={displayHistory}
                  disabled={props.isLoading}
                  sx={{ justifyContent: "center" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.HISTORY} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ToolTip title="Comments">
                <ListItemButton
                  onClick={addComment}
                  disabled={props.isLoading}
                  sx={{ justifyContent: "center" }}
                >
                  <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                    <GoogleMaterialIcon name={ICONS.COMMENT} size={24} color={primaryColor} />
                  </ListItemIcon>
                </ListItemButton>
              </ToolTip>
            </ListItem>
          </List>
        </nav>
      </Box>
    </React.Fragment>
  );
}
